import { twMerge } from 'tailwind-merge';

interface ErrorMessageProps {
  message: string | React.ReactNode;
  className?: string;
}

export const ErrorMessage = ({ message, className }: ErrorMessageProps) => {
  return (
    <div
      className={twMerge(
        'text-[12.5px] font-semibold text-red-FF2929',
        className
      )}
    >
      {message}
    </div>
  );
};
